import { SBox } from '@avalara/skylab-sdk/react';
import React from 'react';
import styled from 'styled-components';
import { FixedWidthPlanWrapper } from '../shared/styles';
import { formatPrice } from '../../../../../shared/helpers';
import { getOfferPlanPrice } from '../../../../lib/offers';
import SelectPlanButton from '../shared/select-plan-button';
const HalfHr = styled.hr `
  width: 50%;
  margin: auto;
`;
const NormalHeightP = styled.p `line-height: normal !important;`;
const ExemptionsOfferPlan = ({ plan, onSelect, selected, isDisabled }) => {
    const offerPlanPrice = getOfferPlanPrice(plan);
    return React.createElement(FixedWidthPlanWrapper, { onClick: onSelect, selected: selected, disabled: isDisabled },
        React.createElement(SBox, { className: 'margin-bottom-sm margin-top-xs text-center' },
            React.createElement("div", { className: 'margin-all-sm' },
                React.createElement("p", { className: 'text-md' }, "Up to"),
                React.createElement(NormalHeightP, { className: 'text-xxl' }, plan.certificatesIncluded || '---'),
                React.createElement("p", { className: 'text-md' }, "certificates")),
            React.createElement(HalfHr, null),
            React.createElement("div", { className: 'margin-all-sm' },
                React.createElement("p", { className: 'text-md inline font-light' }, formatPrice(offerPlanPrice, 0)),
                React.createElement("p", { className: 'text-md inline font-light' }, " annually")),
            React.createElement("div", { className: 'pad-bottom-sm pad-top-md' },
                React.createElement(SelectPlanButton, { isSelected: selected, planName: plan.name, disableButton: isDisabled }))));
};
export default ExemptionsOfferPlan;
